module.exports = {"id":"184626","name":"Nicolás Sánchez","rating":"74","photo":"./data/images/photos/1/184626.png","club":{"name":"Monterrey","logo":"./data/images/clubs/Monterrey.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NicolasSanchez0.json
// module id = 3211
// module chunks = 0